import { render, staticRenderFns } from "./detail_issue-tabs.vue?vue&type=template&id=e125bde6&lang=pug&"
import script from "./detail_issue-tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./detail_issue-tabs.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports